import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import TeamIllustrationSrc from "images/team-illustration-2.svg";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg";

const Container = tw.div`relative`;

const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-16 md:py-20 items-center`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const GetStartedButton = tw.button`w-full bg-primary-500 text-gray-100 font-bold ml-2 mr-2 my-4 sm:my-2 rounded-full py-4 flex items-center justify-center items-center sm:w-40 sm:leading-none focus:outline-none hover:bg-primary-900 transition duration-300`;
const ImageColumn = tw(Column)`md:w-6/12 flex-shrink-0 justify-center relative`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-6/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const Image = styled.img((props) => [
  props.imageRounded && tw`rounded`,
  props.imageBorder && tw`border`,
  props.imageShadow && tw`shadow`,
]);

const DecoratorBlob = styled(SvgDotPattern)(() => [
  tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`,
]);

const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw.h1`font-bold text-3xl md:text-3xl lg:text-4xl xl:text-5xl text-gray-900 leading-tight`;
const ButtonContainer = tw.div`mr-2 my-4 sm:my-2 py-4  md:ml-16  `;
const Steps = tw.ul`mt-12`;
const Step = tw.li`mt-8 flex flex-col md:flex-row items-center md:items-start`;
const StepNumber = tw.div`font-semibold text-4xl leading-none text-gray-400`;
const StepText = tw.div`mt-3 md:mt-0 md:ml-6`;
const StepHeading = tw.h6`leading-none text-xl font-semibold mt-1`;
const StepDescription = tw.p`mt-3 max-w-sm leading-loose text-sm text-gray-700 `;

export default ({
  subheading = "Our Expertise",
  heading = (
    <>
      Designed & Developed by <span tw="text-primary-500">Professionals.</span>
    </>
  ),
  imageSrc = TeamIllustrationSrc,
  imageRounded = true,
  imageBorder = false,
  imageShadow = false,
  imageDecoratorBlob = false,
  textOnLeft = true,
  steps = null,
  decoratorBlobCss = null,
  onGetStartedClick = () => {
    window.location.href = "/login";
  },
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.

  const defaultSteps = [
    {
      heading: "Add contacts",
      description:
        "Post your contact list into the spreadsheet. You can also connect to import contacts through your CRM.",
    },
    {
      heading: "Set up campaign",
      description:
        "Build your messaging campaign for Mass Text.Then pick the contact list to which you wish to send your message.",
    },
    {
      heading: "Preliminary Email",
      description:
        "Construct your text message, customize it with custom fields (fusion tags), such as {first name}.",
    },
    {
      heading: "Set a schedule",
      description:
        "Set the time that you want your message sent, ideally when you think that your audience will be most inclined to take action on it.",
    },
  ];

  if (!steps) steps = defaultSteps;
  const [maxWidth, setMaxWidth] = useState(500);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 769) {
        setMaxWidth(300);
      } else {
        setMaxWidth(500);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
          <Image
            src={imageSrc}
            // style={{ maxWidth: 500  }}
            style={{ maxWidth: `${maxWidth}px` }}
            imageBorder={imageBorder}
            imageShadow={imageShadow}
            imageRounded={imageRounded}
          />
          {imageDecoratorBlob && <DecoratorBlob css={decoratorBlobCss} />}
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            <Subheading>{subheading}</Subheading>
            <Heading>{heading}</Heading>
            <Steps>
              {steps.map((step, index) => (
                <Step key={index}>
                  <StepNumber>
                    {(index + 1).toString().padStart(2, "0")}
                  </StepNumber>
                  <StepText>
                    <StepHeading>{step.heading}</StepHeading>
                    <StepDescription>{step.description}</StepDescription>
                  </StepText>
                </Step>
              ))}
            </Steps>
            <ButtonContainer>
              <GetStartedButton onClick={onGetStartedClick}>
                Get Started
              </GetStartedButton>
            </ButtonContainer>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
